/**
 * 路由守卫配置
 */
import store from '@/store'

/**
 * 获取用户角色
 * @returns {string|null}
 */
function getUserRole() {
  const userType = parseInt(localStorage.getItem('userType'))
  // 0: 管理员, 1: 从业人员, 2: 超级管理员
  return userType === 0
    ? 'admin'
    : userType === 1
    ? 'practitioner'
    : userType === 2
    ? 'superadmin'
    : null
}

/**
 * 配置路由守卫
 * @param {VueRouter} router
 */
export function setupRouterGuard(router) {
  // 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const token = localStorage.getItem('token')
    const userRole = getUserRole()

    // 1. 公开页面直接放行
    if (to.meta.public) {
      next()
      return
    }

    // 2. 需要登录的页面
    if (to.matched.some((record) => record.meta.requiresAuth)) {
      if (!token) {
        // 超级管理员跳转到超级管理员登录页
        if (to.path.startsWith('/superadmin')) {
          next('/login/super-admin')
        } else {
          next('/401')
        }
        return
      }

      // 有 token 但没有用户信息时，获取用户信息（超级管理员不需要）
      const hasUserInfo = store.state.user.userInfo
      if (!hasUserInfo && userRole !== 'superadmin') {
        try {
          await store.dispatch('user/getUserInfo')
        } catch (error) {
          console.error('获取用户信息失败:', error)
        }
      }

      // 检查角色权限
      const routeRole = to.matched.find((record) => record.meta.role)?.meta.role
      if (routeRole && routeRole !== userRole) {
        // 角色不匹配，跳转到对应首页
        if (userRole === 'admin') {
          next('/admin/dashboard')
        } else if (userRole === 'practitioner') {
          next('/practitioner/data-fill')
        } else if (userRole === 'superadmin') {
          next('/superadmin/user-management')
        } else {
          next('/401')
        }
        return
      }

      next()
      return
    }

    // 3. 其他情况放行
    next()
  })

  // 全局后置钩子
  router.afterEach((to) => {
    // 设置页面标题
    document.title = to.meta.title
      ? `${to.meta.title} - 托育行业数据平台`
      : '托育行业数据平台'
  })
}

/**
 * 检查是否有权限
 * @param {Array} roles - 用户角色
 * @param {Array} routeRoles - 路由所需角色
 */
export function hasPermission(roles, routeRoles) {
  if (!routeRoles || routeRoles.length === 0) {
    return true
  }
  return roles.some((role) => routeRoles.includes(role))
}
